// extracted by mini-css-extract-plugin
export default {"container":"PageSubHeader--container--lKQjt"};